module.exports = __webpack_public_path__ + "img/bfmtv.d2c22749.svg";